import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { Feature } from './types';

interface Props {
  anchor: Element | null;
  handleClose: React.EventHandler<any>;
  features: Feature[];
}

const FeaturesPreventingDowngradePopover: React.FC<Props> = ({ anchor, handleClose, features }) => {
  const open = Boolean(anchor);

  const createFeatureWarningText = (feature: Feature) => {
    let featureWarning;

    switch (feature.type) {
      case 'amount':
        featureWarning = (
          <>
            {`${feature.plan} ${feature.name} `}
            <strong>
              {`(currently using ${feature.current})`}
            </strong>
          </>
        );
        break;
      case 'flag':
        featureWarning = (
          <>
            {`${feature.name} `}
            <strong>
              {`(currently ${feature.current ? 'being used' : 'not being used'})`}
            </strong>
          </>
        );
        break;
      default:
        break;
    }

    return featureWarning;
  };

  return (
    <Popover
      sx={{ pointerEvents: 'none' }}
      open={open}
      anchorEl={anchor}
      anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
      transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      onClose={handleClose}
      disableRestoreFocus
    >
      <Box sx={{ padding: 2 }}>
        <Typography variant="body1">
          Plan unavailable
        </Typography>
        <Typography variant="body2">
          The features you are currently using are not available on this plan.
        </Typography>
        <List dense>
          {features.map((feature) => (
            <ListItem key={feature.name} disableGutters>
              <ListItemIcon sx={{ minWidth: 0, marginRight: 1 }}>
                <CancelTwoToneIcon sx={{ color: '#EB1300' }} />
              </ListItemIcon>
              <ListItemText primary={createFeatureWarningText(feature)} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Popover>
  );
};

export default FeaturesPreventingDowngradePopover;
